import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  box-sizing: border-box;
  > a {
    text-decoration: none;
  }
`;

const BookButton = styled.div`
  width: 100%;
  height: 40px;
  margin-bottom: 8px;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  border-radius: 6px;
  ${props => (props.isMasterTrip ? `
    background-color: ${(props.disabled ? props.theme.lightGray1 : props.theme.greenLighter)};
  ` : `
    background-color: ${(props.disabled ? props.theme.lightGray1 : props.theme.orange)};
  `)}
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BookText = styled.span`
  font-size: ${props => props.theme.fontSize.button}px !important;
  font-weight: ${props => props.theme.fontWeight.medium} !important;
  color: ${props => props.theme.white} !important;
`;

const MessageButton = styled.div`
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  border-radius: 6px;
  width: 100%;
  height: 40px;
  background-color: ${props => (props.disabled ? props.theme.lightGray1 : props.theme.white)};
  border: solid 1px ${props => props.theme.blueGray};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MessageText = styled.span`
  font-size: 15px !important;
  font-weight: ${props => props.theme.fontWeight.medium} !important;
  color: ${props => (props.disabled ? props.theme.white : props.theme.darkBlue)} !important;
`;

const BookActionDesktop = (props) => {
  const {
    label,
    messageLabel,
    linkContainer,
    bookLink,
    messageLink,
    disabled,
    customize,
    customizeLabel,
    messageLinkProps,
    hideMessageButton,
    isMasterTrip
  } = props;
  const isTrip = props.trip.product_type === 'trip';
  return (
    <Container>
      {/* <PriceContainer customize={customize}>
        <Typo.Paragraph>Total</Typo.Paragraph>
        <PriceTextRight>
          {ticketPrice ?  // eslint-disable-line
            (<SpanBig>Start from {currency} {commaizeInt(ticketPrice)}</SpanBig>)
            : (isLoadingPricing ? <div><LineLoader /></div> : discountedPrice && (<SpanBig>{currency} {discountedPrice}</SpanBig>)) || 0
          }
          {price > discountedPrice && <StrikePrice>{currency} {commaizeInt(price)}</StrikePrice>}
          <Satisfaction>100% Satisfaction guaranteed</Satisfaction>
        </PriceTextRight>
      </PriceContainer> */}
      {customize && (
        <BookButton isMasterTrip={isMasterTrip} onClick={disabled ? null : props.onClickCustomize} disabled={disabled}>
          <BookText>{customizeLabel}</BookText>
        </BookButton>
      )}
      {!customize && React.cloneElement(linkContainer, { href: (disabled ? null : bookLink), onClick: (disabled ? null : props.onClickBook) }, (
        <BookButton isMasterTrip={isMasterTrip} disabled={disabled}>
          <BookText>{label}</BookText>
        </BookButton>
      ))}
      {!hideMessageButton && !isTrip && !customize && React.cloneElement(linkContainer, { href: (disabled ? null : messageLink), onClick: (disabled ? null : props.onClickMessage), ...messageLinkProps }, (
        <MessageButton disabled={disabled}>
          <MessageText disabled={disabled}>{messageLabel}</MessageText>
        </MessageButton>
      ))}
    </Container>
  );
};

BookActionDesktop.defaultProps = {
  label: 'Book',
  messageLabel: 'Ask Local Expert',
  customizeLabel: 'Request Customize',
  linkContainer: <a />,
  hideMessageButton: false
};

BookActionDesktop.propTypes = {
  label: PropTypes.string,
  messageLabel: PropTypes.string,
  linkContainer: PropTypes.element,
  bookLink: PropTypes.string,
  messageLink: PropTypes.string,
  disabled: PropTypes.bool,
  onClickBook: PropTypes.func,
  onClickMessage: PropTypes.func,
  customize: PropTypes.bool,
  customizeLabel: PropTypes.string,
  onClickCustomize: PropTypes.func,
  messageLinkProps: PropTypes.object,
  hideMessageButton: PropTypes.bool,
  isMasterTrip: PropTypes.bool,
};

export default BookActionDesktop;
